import React, { ChangeEvent, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { Box, FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { searchInput } from '../shared/styleClasses';

interface SearchBarProps {
  onSearchChange: (query: string) => void;
  onSearch: () => void;
  onClear: () => void;
  placeholder: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearchChange,
  onSearch,
  onClear,
  placeholder
}) => {
  const [inputValue, setInputValue] = useState<string>('');

  const debouncedAPICall = useDebouncedCallback(() => {
    onSearchChange(inputValue);
  }, 600);

  const handleQueryChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    debouncedAPICall();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onSearch();
    }
  };

  const searchInputAdornment = () => {
    if (inputValue) {
      return (
        <InputAdornment sx={{ padding: '0px 0px 0px 14px' }} position="start" onClick={onClear}>
          <CloseIcon sx={{ marginBottom: '3.5px' }} />
        </InputAdornment>
      );
    } else {
      return (
        <InputAdornment sx={{ padding: '0px 0px 0px 14px' }} position="start" onClick={onSearch}>
          <SearchIcon />
        </InputAdornment>
      );
    }
  };

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <FormControl fullWidth>
        <OutlinedInput
          sx={searchInput}
          placeholder={placeholder}
          value={inputValue}
          onChange={handleQueryChange}
          onKeyDown={handleKeyDown}
          startAdornment={searchInputAdornment()}
        />
      </FormControl>
    </Box>
  );
};

export default SearchBar;
